/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 上市公司财务情况概览
 */

import React, { PureComponent } from 'react';
import cns from 'classnames';
import { Tabs } from 'antd';
import GroupBox from '../../common/groupBox/GroupBox';
import Newest from './state/Newest';
import File from './state/File';
import Statistics from './state/Statistics';
const TabPane = Tabs.TabPane;

export default class FinancialOverview extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { options } = this.props;
        return (
            <div className="base-panel">
                <GroupBox
                    title="监管动态"
                >
                    <Tabs defaultActiveKey="trends" animated={false} className={cns('line-tabs margin')} >
                        <TabPane tab="最新动态" key="trends">
                            <Newest />
                        </TabPane>
                        <TabPane tab="监管文件" key="file">
                            <File options={options}/>
                        </TabPane>
                        <TabPane tab="统计信息" key="statistics">
                            <Statistics />
                        </TabPane>
                    </Tabs>

                </GroupBox>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/State.jsx